// extracted by mini-css-extract-plugin
export var boxItems = "_7t-1";
export var boxItemsLg = "_7t-2";
export var button = "_7t-7";
export var buttonHoverless = "_7t-9";
export var buttonLg = "_7t-8";
export var filterGroupBox = "_7t-0";
export var icon = "_7t-3";
export var iconSecondary = "_7t-6";
export var iconWrapper = "_7t-4";
export var iconWrapperLg = "_7t-5";
export var truncatedLabel = "_7t-a";